import React, { useState } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { headerData } from "./headerConstant";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import Faq from "./Faq";

function NestedList(props) {
  const { toggleDrawer } = props;
  const [openId, setOpenId] = useState(null); // Track only one open item

  const handleExpandClick = (id) => () => {
    // If the clicked id is already open, close it; otherwise, set the new open id
    setOpenId((prevOpenId) => (prevOpenId === id ? null : id));
  };

  return (
    <Box>
      <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
        {headerData.map((item) => (
          <React.Fragment key={item.id}>
            <ListItemButton onClick={handleExpandClick(item.id)}>
              <Box sx={{ mr: "auto" }}>
                <ListItemText primary={item.title} />
                <Typography sx={{ color: "gray", fontSize: "0.9rem" }}>
                  {item.subTitle}
                </Typography>
              </Box>
              {openId === item.id ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openId === item.id} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.items.map((subItem) => (
                  <ListItemButton
                    onClick={toggleDrawer(false)}
                    key={subItem.id}
                    sx={{ pl: 4, color: "black" }}
                  >
                    {/* <ListItemText primary={subItem.label} />{" "} */}
                    <Link to={subItem.url} className="bg-gray-50  min-w-full">
                      {subItem.label}
                    </Link>
                    <ArrowOutwardIcon />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
            <Divider />
          </React.Fragment>
        ))}
      </List>
      {/* <Box
				sx={{
					display: "flex",
					flexDirection: "column",
					padding: "1rem",
					gap: "0.5rem",
				}}>
				<Link style={{ textDecoration: "none", color: "black" }}>
					Customer Portal Login
				</Link>
				<Divider sx={{ my: "1rem" }} />
				<Link style={{ textDecoration: "none", color: "black" }}>
					Customer Service
				</Link>
			</Box> */}
    </Box>
  );
}

export default NestedList;
